import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {LeadContactsPage} from "./-page/lead-contacts.page";
import {LeadContactsPending} from "./-page/lead-contacts.pending";
import {leadContactsSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/sales/leads/$leadId/contacts/")({
  component: RouteComponent,
  pendingComponent: LeadContactsPending,
  staticData: {meta: {labelDescriptor: routeMessages.contacts}},
  validateSearch: (search) => leadContactsSearchSchema.parse(search),
});

function RouteComponent() {
  const {leadId} = useParams({strict: false}) as {leadId: string};
  const {includeDeleted} = Route.useSearch();

  return <LeadContactsPage includeDeleted={includeDeleted} leadId={leadId} />;
}
